import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, umsUrl } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { FAB_SURGE_UPDATE_USER_STATUS, FAB_SURGE_UPDATE_USER_STATUS_ERROR, FAB_SURGE_UPDATE_USER_STATUS_SUCCESS } from '../../../actions.js';

function* updateFabUserStatus({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/update`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
      // data: payload,
      params: payload,
    });

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FAB_SURGE_UPDATE_USER_STATUS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: FAB_SURGE_UPDATE_USER_STATUS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FAB_SURGE_UPDATE_USER_STATUS_ERROR, payload: error });
  }
}

export function* watchUpdateFabUserStatus() {
  yield takeEvery(FAB_SURGE_UPDATE_USER_STATUS, updateFabUserStatus);
}

function* updateFabUserStatusSaga() {
  yield all([fork(watchUpdateFabUserStatus)]);
}

export default updateFabUserStatusSaga;
